import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Button, Badge } from 'reactstrap'; 
import serverRequest from '../../../utils/serverRequest';
import './Atena.css';

// Paleta de Cores Consistente
const palette = {
  headerGrad: 'linear-gradient(135deg, #0a0f2b 0%, #1b2357 45%, #4b2b8a 100%)',
  cardBg: '#00000000', // Mantido transparente conforme sua última versão
  cardBgHover: '#162243',
  cardBorder: '#1c2a57',
  text: '#eaeefb',
  subText: '#b9c2f2',
  inputBg: '#000',
  inputBorder: '#2b3f7a',
  inputBorderFocus: '#6c5ce7',
  primary: '#6c5ce7',
  primaryHover: '#5b4dd0',
  danger: '#e74c3c',
  success: '#2ecc71',
  warning: '#f1c40f',
  info: '#3498db'
};

// Estilo principal da página (reutilizado do AtenaMeusChamados)
const pageContainerStyle = {
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-start', // Alinha o Container no topo
  padding: '2rem 1rem',
  backgroundImage: "url('/img/bg-gorila.png')", 
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat'
};

const notificationCardStyle = {
    color: palette.text,
    background: palette.cardBg,
    border: `1px solid ${palette.cardBorder}`,
    borderRadius: 12,
    marginBottom: 10,
    padding: '12px 16px',
    transition: 'all 0.3s',
};


export default function AtenaNotificacoes() {
  const [unread, setUnread] = useState(0);
  const [itens, setItens] = useState([]);
  const [loading, setLoading] = useState(true);

  async function refresh() {
    setLoading(true);
    try {
        const c = await serverRequest.request('/atena/notificacoes/contador', {});
        setUnread(c?.unread || 0);

        const r = await serverRequest.request('/atena/notificacoes/listar', { limit: 50, offset: 0 });
        setItens(Array.isArray(r) ? r : []);
    } catch (e) {
        console.error("Erro ao carregar notificações:", e);
        setItens([]);
    } finally {
        setLoading(false);
    }
  }

  useEffect(() => { refresh(); }, []);

  async function marcarTudo() {
    await serverRequest.request('/atena/notificacoes/marcar-todas-lidas', {});
    refresh();
  }

  // Função auxiliar para determinar a cor do título (lida/não lida)
  function getTitleColor(isLida) {
    return isLida ? palette.subText : palette.text;
  }
  
  // Função para Voltar ao menu principal (ajuste o href se o seu menu principal for outro)
  const handleVoltar = () => {
      window.location.hash = '#/'; // Redireciona para a raiz do seu aplicativo
  };

  return (
    <div style={pageContainerStyle}>
      <Container style={{ maxWidth: 800 }}>
        <Row>
          <Col>
            {/* Header Estilizado */}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 25, borderBottom: `2px solid ${palette.cardBorder}`, paddingBottom: 15 }}>
              <h1 style={{ color: palette.text, fontWeight: 700, margin: 0 }}>
                🔔 Notificações 
                {unread > 0 && (
                    <Badge color="primary" style={{ background: palette.danger, marginLeft: 10, padding: '0.4em 0.6em' }}>
                        {unread} Novas
                    </Badge>
                )}
              </h1>
              
              <div style={{ marginLeft: 'auto', display: 'flex', gap: '10px' }}>
                {/* 💡 NOVO BOTÃO VOLTAR */}
                <Button 
                    color="secondary"
                    outline 
                    onClick={handleVoltar}
                    style={{ 
                        color: palette.subText, 
                        borderColor: palette.cardBorder, 
                        background: 'transparent'
                    }}
                >
                    &larr; Voltar
                </Button>
                
                {unread > 0 && (
                  <Button 
                    color="primary" 
                    onClick={marcarTudo}
                    style={{ background: palette.primary, border: 'none' }}
                  >
                    Marcar todas como lidas
                  </Button>
                )}
              </div>
            </div>

            {/* Lista de Notificações */}
            <div className="list-container">
              {loading ? (
                <p style={{ color: palette.subText, textAlign: 'center', padding: '50px 0' }}>Carregando...</p>
              ) : itens.length === 0 ? (
                <div className="empty" style={{ color: palette.subText, textAlign: 'center', padding: '50px 0' }}>
                    Sem notificações.
                </div>
              ) : (
                itens.map(n => (
                  <div 
                    key={n.id} 
                    className="notif-row-modern" 
                    style={{
                        ...notificationCardStyle,
                        // Borda sutil de destaque para não lidas
                        borderColor: n.lida ? palette.cardBorder : palette.primary, 
                        borderLeft: n.lida ? '1px solid ' + palette.cardBorder : '4px solid ' + palette.primary 
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.background = palette.cardBgHover)}
                    onMouseLeave={(e) => (e.currentTarget.style.background = palette.cardBg)}
                  >
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        {/* Conteúdo da Notificação */}
                        <div style={{ flexGrow: 1 }}>
                            <div style={{ 
                                fontWeight: n.lida ? 400 : 700, 
                                color: getTitleColor(n.lida),
                                fontSize: '1.05em'
                            }}>
                                {n.titulo} 
                                <span style={{ color: palette.subText, fontWeight: 400, marginLeft: 10 }}>
                                    {n.mensagem}
                                </span>
                            </div>
                            <small style={{ color: palette.subText, marginTop: 5, display: 'block' }}>
                                Recebido em: {new Date(n.criado_em).toLocaleDateString()}
                            </small>
                        </div>
                        
                        {/* Botão de Ação */}
                        <div style={{ marginLeft: 20 }}>
                            {n.url_destino && (
                                <a href={n.url_destino} style={{ textDecoration: 'none' }}>
                                    <Button color="link" style={{ color: palette.primary }}>
                                        Abrir &rarr;
                                    </Button>
                                </a>
                            )}
                        </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}